import { useCallback, useMemo } from "react";
import { Col, Row, Form } from "react-bootstrap";
import ReactSelect from "react-select";
import DimensionAllocations from "./DimensionAllocations";

export default function DimensionSelectionSection({
  t,
  dimensionKey,
  dimensionName,
  dimensionId,
  dimensionOptions,
  selectedItems,
  setSelectedItems,
  errorText,
  isPersonal,
  isMulti,
  dimensionAllocSum,
  dimensionAllocValid,
  handleDimensionAllocChange,
  CheckboxOption,
  reactSelectSearchSettings
}) {

  const getId = (o) => String(o?.id ?? o?.codeKey ?? o?.value);

  const handleAlloc = useMemo(
    () => handleDimensionAllocChange(dimensionKey, dimensionId),
    [handleDimensionAllocChange, dimensionKey, dimensionId]
  );

  const onProjectsAllocChange = useCallback((allocs) => {
    const percentById = new Map(
      (allocs || []).map(a => [getId(a), Number(a.percent) || 0])
    );

    setSelectedItems(prev => {
      let changed = false;
      const next = (prev || []).map(it => {
        const id = getId(it);
        if (!percentById.has(id)) return it;
        const p = percentById.get(id);
        if (Number(it.percent) === p) return it;
        changed = true;
        return { ...it, percent: p };
      });
      return changed ? next : prev;
    });

    handleAlloc(allocs);
  }, [setSelectedItems, handleAlloc]);

  return (
    <>
      <Row className="align-items-end">
        <Col xs={12} md={9}>
          <Form.Group controlId={`dimensionSelect${dimensionKey}`}>
            <Form.Label>{dimensionName}</Form.Label>
            <ReactSelect
              className="w-100"
              isMulti={isMulti}
              options={dimensionOptions}
              value={selectedItems}
              getOptionValue={(o) => String(o.codeKey ?? o.value)}
              onChange={(vals, meta) => {
                const next = Array.isArray(vals) ? vals : (vals ? [vals] : []);
                setSelectedItems(next);
              }}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ Option: CheckboxOption }}
              isOptionDisabled={(option) => option.active === false}
              isDisabled={isPersonal}
              {...reactSelectSearchSettings(t)}
            />
            {errorText && (
              <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                {errorText}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        {selectedItems.length > 0 && (
          <Col xs={12} md={3} className="ms-md-auto mt-2 mt-md-0">
            <div className={`alert alert-${!dimensionAllocValid ? "danger" : "success"} p-2 mb-0 d-flex gap-1 justify-content-center`}>
              <strong>{t("Prosenttiosuus", "Prosenttiosuus")}</strong>
              <div className="mx-1 text-nowrap">{dimensionAllocSum}%</div>
            </div>
          </Col>
        )}
      </Row>

      <DimensionAllocations
        selectedOptions={selectedItems}
        disabled={isPersonal}
        onChange={onProjectsAllocChange}
        onRequestRemove={(id) => {
          setSelectedItems(prev =>
            prev.filter(o => String(o.value ?? o.codeKey) !== String(id))
          );
        }}
        validPercentages={dimensionAllocValid}
      />
    </>
  );
}
